var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing,
    colors = _ref.colors,
    typography = _ref.typography;
  return {
    headerBackgroundColor: colors.contrasts.grey1111,
    headerColor: colors.contrasts.grey100100,
    headerPadding: "".concat(spacing.xSmall, " ").concat(spacing.small)
  };
};
export default generateComponentTheme;